// app-advantages-carousel.js — layer state for the advantages slider.
//
// Brief D-2: on desktop the 4 cards occupy the full 1400px content width,
// so slidesPerView === totalCards and Figma removes the nav row entirely.
// Below 768px the same slider is a 1-up peek-through with prev/next arrows.
//
// This keeps the DOM honest about that: `.slide-no-arrows` (the slider
// template's own JS-bound class) is present exactly when the track cannot
// scroll. css/sections/app-advantages-carousel.css also hides the controls
// at >=768px, so the layout is correct with JS disabled — this script only
// aligns the class state.
//
// Registered AFTER slider.js so slider.js still wires the buttons at
// DOMContentLoaded (both scripts are deferred and run in document order);
// otherwise a page first painted at desktop width would leave the arrows
// permanently unwired for a later resize down to mobile.
document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.advantages__slider');
  if (!wrapper) return;

  var mq = window.matchMedia('(min-width: 768px)');

  function sync(e) {
    wrapper.classList.toggle('slide-no-arrows', e.matches);
  }

  sync(mq);
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
});
